import {
    CompressionFormat,
    Export,
    ExportFileFormats,
    ExportStatus,
    ExportTypes,
    TaskType,
} from '@dev/ee-api/ee-api-models';
import { Action } from 'redux';
export interface ExportContactsParams {
    fileFormat: ExportFileFormats;
    rule?: string;
    emails?: string[];
    compressionFormat: CompressionFormat;
    fileName: string;
}

export interface ExportData {
    Link?: string;
    PublicExportID?: string;
}

export interface ExportContactsStartAction extends Action {
    type: '@@export/CONTACTS_START';
    payload: {
        params: ExportContactsParams;
    };
}

export interface ExportContactsErrorAction extends Action {
    type: '@@export/CONTACTS_ERROR';
}

export interface ExportContactsSuccessAction extends Action {
    type: '@@export/CONTACTS_SUCCESS';
    payload: {
        data: ExportData;
    };
}

export const INITIAL_PER_PAGE = 25;
export interface ExportsPayload {
    limit?: number;
    offset?: number;
    search?: string;
    activePage?: number;
    exportsPerPage?: number;
    type?: TaskType;
    counts?: ExportsCount;
    statuses?: ExportStatus[];
    types?: ExportTypes[];
    supressLoadIndicator?: boolean;
}

export type ExportsCount = {
    totalCount: number;
    readyCount: number;
    loadingCount: number;
    verifiedCount: number;
    expiredCount: number;
    errorCount: number;
    campaingCount: number;
    contactCount: number;
    linktrackingCount: number;
    logCount: number;
    surveyCount: number;
    unsubscribereasonCount: number;
    singleemailverificationCount: number;
    emailverificationlistCount: number;
    linkcontactsCount: number;
    emailverificationCount: number;
    channelCount: number;
};

export interface LoadExportsAction extends Action {
    type: '@@exports/FETCH_EXPORTS';
    payload: ExportsPayload;
}

export interface LoadExportsStartAction extends Action {
    type: '@@exports/FETCH_EXPORTS_START';
}

export interface LoadExportsSuccessAction extends Action {
    type: '@@exports/FETCH_EXPORTS_SUCCESS';
    payload: { exportsList: Export[]; counts: ExportsCount };
}

export interface LoadExportsErrorAction extends Action {
    type: '@@exports/FETCH_EXPORTS_ERROR';
}

export interface FilterExportsAction extends Action {
    type: '@@exports/FILTER_EXPORTS';
    payload: ExportsPayload;
}

export interface DeleteExportsAction extends Action {
    type: '@@exports/DELETE_EXPORTS';
    payload: {
        id: string;
    };
}
export interface SearchExportsAcion extends Action {
    type: '@@exports/SEARCH_EXPORTS';
    payload: ExportsPayload;
}

export interface DeleteExportsStartAction extends Action {
    type: '@@exports/DELETE_EXPORTS_START';
}

export interface DeleteExportsErrorAction extends Action {
    type: '@@exports/DELETE_EXPORTS_ERROR';
}

export interface DeleteExportsSuccessAction extends Action {
    type: '@@exports/DELETE_EXPORTS_SUCCESS';
}

export interface RestoreDefaultStoreAction extends Action {
    type: '@@exports/RESTORE_DEFUALT_STORE';
}

export interface BeginPollingExportsAction extends Action {
    type: '@@exports/BEGIN_POLLING_EXPORTS';
    payload: ExportsPayload;
}

export interface CancelPollingExportsAction extends Action {
    type: '@@exports/CANCEL_POLLING_EXPORTS';
}

export interface ExportsState {
    params: ExportContactsParams;
    data: ExportData;
    exporting: boolean;
    exportsLoading: boolean;
    exportsList?: Export[];
    statuses?: ExportStatus[];
    types?: ExportTypes[];
    selectedExports?: string[];
    counts?: ExportsCount;
    activePage?: number;
    exportsPerPage?: number;
    type?: TaskType;
    search?: string;
}
